// Lista de provincias argentinas con sus IDs
const provinces = [
  { id: 2, name: "BUENOS AIRES" },
  { id: 3, name: "CATAMARCA" },
  { id: 4, name: "CHACO" },
  { id: 5, name: "CHUBUT" },
  { id: 1, name: "CIUDAD AUTONOMA DE BUENOS AIRES" },
  { id: 6, name: "CORDOBA" },
  { id: 7, name: "CORRIENTES" },
  { id: 8, name: "ENTRE RIOS" },
  { id: 9, name: "FORMOSA" },
  { id: 10, name: "JUJUY" },
  { id: 11, name: "LA PAMPA" },
  { id: 12, name: "LA RIOJA" },
  { id: 13, name: "MENDOZA" },
  { id: 14, name: "MISIONES" },
  { id: 15, name: "NEUQUEN" },
  { id: 25, name: "Otro" },
  { id: 16, name: "RIO NEGRO" },
  { id: 17, name: "SALTA" },
  { id: 18, name: "SAN JUAN" },
  { id: 19, name: "SAN LUIS" },
  { id: 20, name: "SANTA CRUZ" },
  { id: 21, name: "SANTA FE" },
  { id: 22, name: "SANTIAGO DEL ESTERO" },
  { id: 23, name: "TIERRA DEL FUEGO" },
  { id: 24, name: "TUCUMAN" }
];

export default provinces; 